import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      nav: {
        home: "Home",
        portfolio: "Our Robots",
        contact: "Contact",
        github: "GitHub"
      },
      home: {
        greeting: "Hi, I'm",
        title: "ROSOTA",
        subtitle: "Physical AI Robotics R&D",
        description: "Developing state-of-the-art robots with Vision-Language-Action learning, reinforcement learning, and XR data collection for real-world applications.",
        aboutTitle: "About ROSOTA",
        aboutDescription: "ROSOTA is at the forefront of Physical AI robotics research, developing cutting-edge solutions for medical procedures, autonomous mobile manipulation, and egocentric data collection through XR/HMD systems.",
        sotaModels: "SOTA Models",
        aboutRosota: "About Rosota",
        ourMission: "Our Mission",
        teamLeader: "Team Leader",
        teamMembers: "Team Members",
        roboticsLabLead: "Robotics Lab Lead",
        designLabLead: "Design Lab Lead",
        roboticsEngineer: "Robotics Lab Engineer",
        newsletterTitle: "Subscribe to rosota Newsletter",
        newsletterDesc: "Get the latest research news from the SNU & SNUH-based robotics SOTA research crew delivered straight to your inbox.",
        newsletterPlaceholder: "Enter your email",
        newsletterSubmit: "Subscribe",
        newsletterSuccess: "Welcome! You'll now receive our latest research news.",
        newsletterError: "Something went wrong. Please try again."
      },
      portfolio: {
        title: "Our Robots",
        subtitle: "Discover our cutting-edge robotics solutions designed for Physical AI applications.",
        viewDetails: "View Details",
        orderNow: "Order Now",
        price: "Price",
        contactForPricing: "Contact for pricing",
        comingSoonTitle: "More Robot Models Coming Soon",
        comingSoon: "Coming Soon",
        getQuote: "Get Quote",
        gloveTitle: "Glove Exoskeleton Data Collection Robot",
        gloveDesc: "Advanced glove-shaped exoskeleton robot designed for precise human motion data collection and analysis in physical AI research.",
        surgicalTitle: "Humanoid-based Laparoscopic Surgical Robot",
        surgicalDesc: "Advanced teleoperated humanoid surgical robot system for automated laparoscopic procedures with precision control.",
        customTitle: "Custom Solutions",
        customDesc: "Tailored robotics solutions for specific industry needs and applications."
      },
      checkout: {
        title: "Checkout",
        completeTitle: "Complete Your Purchase",
        noProduct: "No product selected",
        noProductDesc: "Please select a product from the portfolio page.",
        goToPortfolio: "Go to Portfolio",
        orderSummary: "Order Summary",
        total: "Total",
        whatsIncluded: "What's Included:",
        hardware: "Robot Hardware",
        license: "Software License",
        support: "Technical Support",
        warranty: "Warranty Coverage",
        securePayment: "Secure Payment",
        securePaymentDesc: "Your payment information is encrypted and secure.",
        billingInfo: "Billing Information",
        fullName: "Full Name",
        email: "Email",
        address: "Address",
        city: "City",
        zipCode: "Zip Code",
        country: "Country",
        paymentInfo: "Payment Information",
        pay: "Pay",
        processing: "Processing...",
        cancel: "Cancel",
        paymentSuccess: "Payment Successful!",
        thankYou: "Thank you for your order.",
        paymentSetup: "Payment System Setup Required",
        paymentSetupDesc: "To enable payments, please configure your payment gateway."
      },
      contact: {
        title: "Contact Us",
        getInTouch: "Get in touch",
        description: "Feel free to reach out to us for inquiries about our robotics solutions.",
        send: "Send",
        sending: "Sending..."
      },
      footer: {
        allRightsReserved: "All Rights Reserved."
      }
    }
  },
  ko: {
    translation: {
      nav: {
        home: "홈",
        portfolio: "로봇 제품",
        contact: "문의",
        github: "GitHub"
      },
      home: {
        greeting: "안녕하세요,",
        title: "ROSOTA",
        subtitle: "Physical AI 로보틱스 연구개발",
        description: "Vision-Language-Action 학습, 강화학습, XR 데이터 수집을 활용한 실세계 응용을 위한 최첨단 로봇을 개발합니다.",
        aboutTitle: "ROSOTA 소개",
        aboutDescription: "ROSOTA는 Physical AI 로보틱스 연구의 최전선에서 의료 시술, 자율 이동 조작, XR/HMD 시스템을 통한 1인칭 데이터 수집을 위한 최첨단 솔루션을 개발하고 있습니다.",
        sotaModels: "SOTA 모델",
        aboutRosota: "Rosota 소개",
        ourMission: "우리의 미션",
        teamLeader: "팀 리더",
        teamMembers: "팀원",
        roboticsLabLead: "로보틱스 연구실 책임자",
        designLabLead: "디자인 연구실 책임자",
        roboticsEngineer: "로보틱스 연구원",
        newsletterTitle: "rosota 뉴스레터 구독",
        newsletterDesc: "서울대학교·서울대학교병원 기반 Robotics SOTA 연구 크루의 최신 연구 성과와 기술 소식을 가장 빠르게 전해드립니다.",
        newsletterPlaceholder: "이메일을 입력하세요",
        newsletterSubmit: "구독하기",
        newsletterSuccess: "환영합니다, 이제 최신 연구 소식이 도착합니다.",
        newsletterError: "오류가 발생했습니다. 다시 시도해주세요."
      },
      portfolio: {
        title: "로봇 제품",
        subtitle: "Physical AI 응용을 위해 설계된 최첨단 로보틱스 솔루션을 만나보세요.",
        viewDetails: "자세히 보기",
        orderNow: "주문하기",
        price: "가격",
        contactForPricing: "가격 문의",
        comingSoonTitle: "더 많은 로봇 모델 출시 예정",
        comingSoon: "출시 예정",
        getQuote: "견적 문의",
        gloveTitle: "장갑형 외골격 데이터 수집 로봇",
        gloveDesc: "Physical AI 연구를 위한 정밀한 인간 동작 데이터 수집 및 분석을 위해 설계된 첨단 장갑형 외골격 로봇입니다.",
        surgicalTitle: "휴머노이드 기반 복강경 수술 로봇",
        surgicalDesc: "정밀 제어가 가능한 자동 복강경 시술을 위한 첨단 원격 조작 휴머노이드 수술 로봇 시스템입니다.",
        customTitle: "맞춤형 솔루션",
        customDesc: "특정 산업 요구사항 및 응용 분야를 위한 맞춤형 로보틱스 솔루션입니다."
      },
      checkout: {
        title: "결제",
        completeTitle: "구매 완료하기",
        noProduct: "선택된 제품이 없습니다",
        noProductDesc: "포트폴리오 페이지에서 제품을 선택해주세요.",
        goToPortfolio: "포트폴리오로 가기",
        orderSummary: "주문 요약",
        total: "총액",
        whatsIncluded: "포함 내역:",
        hardware: "로봇 하드웨어",
        license: "소프트웨어 라이선스",
        support: "기술 지원",
        warranty: "보증 적용",
        securePayment: "보안 결제",
        securePaymentDesc: "결제 정보는 암호화되어 안전하게 보호됩니다.",
        billingInfo: "결제 정보",
        fullName: "이름",
        email: "이메일",
        address: "주소",
        city: "도시",
        zipCode: "우편번호",
        country: "국가",
        paymentInfo: "결제 수단",
        pay: "결제하기",
        processing: "처리 중...",
        cancel: "취소",
        paymentSuccess: "결제 완료!",
        thankYou: "주문해주셔서 감사합니다.",
        paymentSetup: "결제 시스템 설정 필요",
        paymentSetupDesc: "결제를 활성화하려면 결제 게이트웨이를 구성해주세요."
      },
      contact: {
        title: "문의하기",
        getInTouch: "연락주세요",
        description: "로보틱스 솔루션에 대한 문의사항이 있으시면 언제든 연락주세요.",
        send: "보내기",
        sending: "전송 중..."
      },
      footer: {
        allRightsReserved: "All Rights Reserved."
      }
    }
  }
};

// IP 기반 지역 감지 함수
export const detectRegionFromIP = async () => {
  try {
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();
    const countryCode = data.country_code;

    // 한국이면 'ko', 아니면 'en'
    return countryCode === 'KR' ? 'ko' : 'en';
  } catch (error) {
    console.error('Failed to detect region:', error);
    // 기본값은 영어
    return 'en';
  }
};

// 사용자 언어 감지 설정 (기본 탐지기 사용: localStorage, navigator 등)
const languageDetector = new LanguageDetector();

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'ko'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    cleanCode: true,
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;
